export * from './exist-result-status';
export * from './lookup-category';
export * from './normal-range-list';
export * from './normal-result-type';
export * from './normal-range-status';
export * from './rsiReport';
export * from './sent-external-laboratory-status.enum';
export * from './specimenStatus';
export * from './test-definition-locations';
export * from './test-definition-types';
export * from './test-result-type';
export * from './turnaround-time-types.ts';
export * from './delta-calculation-method';
export * from './delta-comparison-method';
export * from './DeltaBoolean';
export * from './DeltaAgeType';
export * from './DeltaPatientType';